unable to read source [project]/node_modules/stripe/src/crypto/NodeCryptoProvider.ts